import { ArrowRightOutlined } from "@ant-design/icons";
import { useState } from "react";

const RightArrowIcon = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <ArrowRightOutlined
            style={{
                fontSize: "24px",
                color: !isHovered ? "#1890ff" : "rgb(163, 149, 218)", // Change color on hover
                cursor: "pointer",
                transition: "transform 0.3s ease, color 0.3s ease",
                transform: isHovered ? "translateX(8px)" : "translateX(0)", // Move slightly right
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        />
    );
};

export default RightArrowIcon;
